const ADSENSE_EVENTS = {
  REQUESTED: 'adsenseForSearchRequested',
  LOADED: 'adsenseForSearchLoaded',
} as const;

export default ADSENSE_EVENTS;
export const ADSENSE_TOP_CONTAINER_ID = 'adsense-container-top-lazy';
